import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { SUPABASE_URL as URL, SUPABASE_KEY as KEY } from './config';
import { DEMO } from './env';

// My Planner Web: mesma conta e mesmos dados do celular. A sessão fica guardada neste navegador.
// Na prévia de demonstração (EXPO_PUBLIC_DEMO=1) não há servidor.
export const nuvemConfigurada = DEMO || (URL.startsWith('https://') && KEY.length > 20);

export const supabase: SupabaseClient | null = DEMO || typeof window === 'undefined' ? null
  : createClient(URL, KEY, { auth: { storage: window.localStorage, autoRefreshToken: true, persistSession: true, detectSessionInUrl: false } });

export { traduzErro } from './erro';
